@if (loading()) {
  <div class="flex h-full justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else if (timeOut()) {
  <app-timeout></app-timeout>
} @else {
  <div [formGroup]="form" class="modalForm denseGrid">
    <div class="flex flex-column gap-2 mb-3">
      <label for="label" class="font-semibold w-full"
        >{{ "gate_administration.components_list.form.label" | translate }}*</label
      >
      <input pInputText id="label" formControlName="label" autocomplete="off" />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="article" class="font-semibold"
        >{{ "gate_administration.components_list.form.article" | translate }}*</label
      >
      <p-select
        appendTo="body"
        [options]="allArticles()"
        optionLabel="articleNumber"
        [filter]="true"
        filterMatchMode="contains"
        filterBy="articleNumber,label"
        (onChange)="selectArticle($event)"
        (onClear)="clearArticle()"
        [emptyFilterMessage]="translate.instant('common.no_results_found')"
        id="article"
        optionValue="id"
        formControlName="article"
        class="w-full"
        showClear="true"
      >
        <ng-template let-article #selectedItem> {{ article.articleNumber }} - {{ article.label }} </ng-template>
        <ng-template let-article #item> {{ article.articleNumber }} - {{ article.label }} </ng-template>
      </p-select>
    </div>

    @if (selectedArticle) {
      <div class="flex flex-column g-col-1 gap-20px">
        <div class="flex flex-column gap-2 mb-3">
          <span class="label">
            {{ "gate_administration.components_list.form.article_details.inspection" | translate }}
          </span>
          @if (selectedArticle.enableInspection) {
            <span class="selectedArtcleProperty">
              {{ "gate_administration.components_list.form.article_details.active" | translate }}
            </span>
          } @else {
            <span class="selectedArtcleProperty">
              {{ "gate_administration.components_list.form.article_details.inactive" | translate }}</span
            >
          }
        </div>
        @if (selectedArticle.enableInspection) {
          @if (selectedArticle.loadChanges !== null && selectedArticle.loadChanges !== undefined) {
            <div class="flex flex-column gap-2 mb-3">
              <span class="label">
                {{ "gate_administration.components_list.form.article_details.load_changes" | translate }}
              </span>

              <span class="selectedArtcleProperty">{{ selectedArticle.loadChanges | number: "" : "de" }} </span>
            </div>
          }
          @if (selectedArticle.operatingTime !== null && selectedArticle.operatingTime !== undefined) {
            <div class="flex flex-column gap-2 mb-3">
              <span class="label">
                {{ "gate_administration.components_list.form.article_details.operating_time" | translate }}
              </span>
              <span class="selectedArtcleProperty">{{ selectedArticle.operatingTime | number: "" : "de" }} </span>
            </div>
          }
        }
      </div>
      <div class="flex flex-column g-col-2 gap-20px">
        <div class="flex flex-column gap-2 mb-3">
          <span class="label">
            {{ "gate_administration.components_list.form.article_details.exchange" | translate }}
          </span>
          @if (selectedArticle.enableExchange) {
            <span class="selectedArtcleProperty">
              {{ "gate_administration.components_list.form.article_details.active" | translate }}
            </span>
          } @else {
            <span class="selectedArtcleProperty">
              {{ "gate_administration.components_list.form.article_details.inactive" | translate }}</span
            >
          }
        </div>

        @if (selectedArticle.enableExchange) {
          @if (selectedArticle.maxLoadChanges !== undefined && selectedArticle.maxLoadChanges !== null) {
            <div class="flex flex-column gap-2 mb-3">
              <span class="label">
                {{ "gate_administration.components_list.form.article_details.max_load_changes" | translate }}
              </span>
              <span class="selectedArtcleProperty">{{ selectedArticle.maxLoadChanges | number: "" : "de" }} </span>
            </div>
          }
          @if (selectedArticle.maxOperatingTime !== undefined && selectedArticle.maxOperatingTime !== null) {
            <div class="flex flex-column gap-2 mb-3">
              <span class="label">
                {{ "gate_administration.components_list.form.article_details.max_operating_time" | translate }}
              </span>
              <span class="selectedArtcleProperty">{{ selectedArticle.maxOperatingTime | number: "" : "de" }} </span>
            </div>
          }
        }
      </div>
    }

    <div class="flex flex-column gap-2 mb-3">
      <label for="startDate" class="font-semibold"
        >{{ "gate_administration.components_list.form.start_date" | translate }}*</label
      >
      <p-datepicker
        [iconDisplay]="'input'"
        [showIcon]="true"
        id="startDate"
        formControlName="startDate"
        dateFormat="dd.mm.yy"
        inputStyleClass="w-full"
        appendTo="body"
      />
    </div>
    <div class="flex flex-column gap-2 mb-3">
      <label for="historyCycle" class="font-semibold w-full"
        >{{ "gate_administration.components_list.form.history_cycle" | translate }}*</label
      >
      <p-inputNumber class="w-full" id="historyCycle" formControlName="historyCycle" autocomplete="off" />
    </div>
    <!-- Buttons: -->
    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button
        id="cancelGateComponentButton"
        [buttonText]="translate.instant('common.cancel')"
        (click)="closeDialog()"
      ></app-button>
      <app-button
        id="saveGateComponentButton"
        [buttonText]="translate.instant('common.save')"
        [disabled]="!form.valid"
        (click)="save()"
      ></app-button>
    </div>
  </div>
}
